"use client";

import React, { createContext, useContext, useEffect, useState } from "react";
import i18n from "../../i18n";

interface LanguageContextType {
  language: string;
  setLanguage: (lang: string) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(
  undefined,
);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const [language, setLanguageState] = useState(() => {
    if (typeof window !== "undefined") {
      return sessionStorage.getItem("language") || "en";
    }
    return "en";
  });

  const setLanguage = (newLanguage: string) => {
    setLanguageState(newLanguage);
    if (typeof window !== "undefined") {
      sessionStorage.setItem("language", newLanguage);
    }
    i18n.changeLanguage(newLanguage);
  };

  useEffect(() => {
    const storedLanguage = sessionStorage.getItem("language");
    if (storedLanguage && i18n.language !== storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
